
import { MapLocation } from '@/types/location';

// Power Square Gym Locations
export const powerSquareGyms: MapLocation[] = [
  {
    id: 38001,
    name: "Power Square - Riyadh (Al Rabee)",
    type: "Gym",
    devices: 4,
    coordinates: [24.805202271388758, 46.660730649076406],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
